button {
	/* Position */
	position: relative;

	/* Dim */
	width: 35px;
	height: 35px;

	/* Flex */
	display: flex;
	align-items: center;
	justify-content: center;

	/* Spacing */
	box-sizing: border-box;
	padding: 5px 8px 5px 8px;

	/* Cursor */
	cursor: pointer;
	background-color: var(--card-color);

	/* Border */
	border-radius: 5px;
	border-style: solid;
	border-color: var(--border-color);
	border-width: 1px;

	overflow: visible;
}

button:hover {
	background-color: #00000009;
}

a:link {
	text-decoration: inherit;
	color: inherit;
}

a:visited {
	text-decoration: inherit;
	color: inherit;
}

span {
	/* Position */
	position: absolute;
	top: -6px;
	right: -6px;
	z-index: 20;

	/* Color */
	background-color: var(--danger-red);
	color: white;

	/* Text */
	font-size: 11px;
	text-align: center;
	
	/* Spacing */
	padding: 3px;

	/* Dimensions */
	min-width: 12px;

	/* Border */
	border-radius: 100%;
	
}